(function () {
    const root = document.getElementById("lucy-customizer-root");
    if (!root) return;

    const assetsCfg = window.LUCY_CUSTOMIZER_ASSETS || {};
    const fontAssetMap = assetsCfg.fonts || {};
    const glyphMetricsMap = window.LUCY_GLYPH_METRICS || {};
    const fallbackMockupUrl = assetsCfg.mockup || "mockup.jpg";
    const highlightsUrl = assetsCfg.highlights || "mockup_highlights.jpg";
    const renderOptions = Array.isArray(assetsCfg.renders) && assetsCfg.renders.length
      ? assetsCfg.renders
      : [{
        id: "default",
        label: "Salón",
        src: fallbackMockupUrl,
        width: 1536,
        height: 1024,
        plane: {
          tl: { x: 0.18, y: 0.08 },
          tr: { x: 0.78, y: 0.08 },
          br: { x: 0.78, y: 0.58 },
          bl: { x: 0.18, y: 0.58 }
        },
        sceneWidthCm: 340
      }];
    const checkoutEnabled = assetsCfg.checkoutEnabled === true;

    const fonts = ["Sofia", "Tamara", "William", "Musi", "Fifi", "ArtDeco", "Samantha", "Gloria", "Gabriel", "Amelie", "Lidia", "Lalo", "Bingo", "Nacho", "UFO", "Paco", "Martin", "Francesco", "Jedi", "Julia", "Neon", "Madeline",];
    const swatchColors = [
      "#ffffff", "#f5f1e6", "#fff15a", "#ffd64d", "#ff9f2a", "#ff3b30",
      "#00e5ff", "#0033ff", "#ff2da6", "#ffb5d8", "#34c759", "#8e44ff"
    ];

    const state = {
      selectedFont: fonts[0],
      strokeColor: swatchColors[0],
      align: "left",
      view: "render",
      selectedRenderId: renderOptions[0]?.id || "default",
      textAspect: 1200 / 500,
      dimSyncing: false,
      selectedWidthCm: 100,
    };

    const PRICE_CFG = {
      areaRatePerM2: 20,          // from neon-presupuesto.html
      neonRatePerCm: 0.4,         // from neon-presupuesto.html
      laborRatePerCharacter: 5,   // cutting, bending, soldering, wiring, mounting and testing
      fallbackCmPerCharAt100cm: 70,
      fallbackCharExponent: 0.85
    };
    const BASE_PRICE_EUR = 90;
    const PRICING_VERSION = "v4-glyph-metrics-plus-labor";
    const BASE_VARIANT_BY_WIDTH_CM = {
      50: 57651709870412,
      75: 57651709903180,
      100: 57651709935948,
      125: 57651709968716,
      150: 57651710001484,
      200: 57651710034252,
      250: 57651710067020,
      300: 57651710099788
    };
    const ADJUSTMENT_VARIANT_BY_EUR = {
      1: 57651734577484,
      2: 57651734610252,
      5: 57651734643020,
      10: 57651734675788,
      20: 57651734708556,
      50: 57651734741324,
      100: 58016910901580,
      250: 58016910934348,
      500: 58016910967116,
      1000: 58016910999884
    };
    const ADJUSTMENT_DENOMS = [1000, 500, 250, 100, 50, 20, 10, 5, 2, 1];

    // Visual-only placement tuning for the text inside the mockup frame.
    const TEXT_LAYOUT = {
      // Real-world scene width represented by the mockup image (cm).
      // 340cm means full mockup width corresponds to 3.4m.
      sceneWidthCm: 340,
      // Keep text vertically in the wall area and avoid floor overlap.
      maxHeightOfImageRatio: 0.58,
      yBiasRatio: -0.10,
      innerPadPx: 24
    };
    const DIM_ANN = {
      color: "rgba(190, 198, 216, 0.62)",
      textColor: "rgba(210, 218, 236, 0.78)",
      stroke: 1.4,
      tick: 24,
      gap: 16,
      fontSize: 18
    };
    const HIGHLIGHT_CFG = {
      strength: 3.0,
      gamma: 1.4,
      threshold: 6,
      invert: false
    };
    const MIN_HEIGHT_CM = 16;
    const BOARD_SHORT_SIDE_CM = 200;
    const BOARD_LONG_SIDE_CM = 300;
    const FONT_LAYOUT_DEFAULTS = {
      Francesco: { spacing: 22, lineHeight: 50 },
      Julia: { spacing: 0, lineHeight: 50 },
      Lucia: { spacing: -9, lineHeight: 50 },
      Roberto: { spacing: 0, lineHeight: 50 },
      Samantha: { spacing: 0, lineHeight: 50 },
      Gloria: { spacing: 0, lineHeight: 50 },
      Gabriel: { spacing: 0, lineHeight: 50 },
      Amelie: { spacing: 0, lineHeight: 50 },
      Lidia: { spacing: 0, lineHeight: 50 },
      Lalo: { spacing: 0, lineHeight: 50 },
      Bingo: { spacing: 0, lineHeight: 50 },
      Nacho: { spacing: 0, lineHeight: 50 },
      UFO: { spacing: 0, lineHeight: 50 },
      Sofia: { spacing: 0, lineHeight: 50 },
      Tamara: { spacing: 0, lineHeight: 50 },
      William: { spacing: 0, lineHeight: 50 },
      Paco: { spacing: 0, lineHeight: 50 },
      Martin: { spacing: 0, lineHeight: 50 },
      Musi: { spacing: 0, lineHeight: 50 },
      Fifi: { spacing: 0, lineHeight: 50 },
      ArtDeco: { spacing: 0, lineHeight: 50 }
    };
    const FALLBACK_LAYOUT_DEFAULTS = { spacing: 22, lineHeight: 50 };
    const SIZE_CHAR_LIMITS = {
      50: 10,
      75: 13,
      100: 16,
      125: 19,
      150: 22,
      200: 28,
      250: 34,
      300: 40
    };

    const fontCache = new Map();
    const previewFontCache = new Map();
    const mockupMetaCache = new Map();
    let highlightMeta = null;
    const highlightTintCache = new Map();

    const fontGrid = document.getElementById("fontGrid");
    const swatches = document.getElementById("swatches");
    const lengthLabel = document.getElementById("lengthLabel");
    const statusLabel = document.getElementById("statusLabel");
    const diagLabel = document.getElementById("diagLabel");
    const cartLogLabel = document.getElementById("cartLogLabel");
    const neonEstimateLabel = document.getElementById("neonEstimateLabel");
    const priceLabel = document.getElementById("priceLabel");
    const metricRedStroke = document.getElementById("metricRedStroke");
    const metricIThickness = document.getElementById("metricIThickness");
    const metricCombined = document.getElementById("metricCombined");
    const checkoutPriceOld = document.getElementById("checkoutPriceOld");
    const checkoutPriceNow = document.getElementById("checkoutPriceNow");
    const addToCartBtn = document.getElementById("addToCartBtn");
    const checkoutDevelopmentMessage = document.getElementById("checkoutDevelopmentMessage");
    const checkoutWhatsapp = root.querySelector(".checkout-whatsapp");
    const viewer = document.getElementById("viewer");
    const mockupBg = viewer ? viewer.querySelector(".mockup-bg") : null;
    const viewerStage = viewer ? viewer.querySelector(".viewer-stage") : null;
    const renderSwitcher = document.getElementById("renderSwitcher");
    const svgShell = document.getElementById("svgShell");
    const sizeGrid = document.getElementById("sizeGrid");
    const sizeChips = Array.from(sizeGrid.querySelectorAll(".size-chip"));
    const diagnostics = [];

    function initFinalGallery() {
      const modal = document.getElementById("finalGalleryModal");
      const modalImage = document.getElementById("finalGalleryModalImage");
      const items = Array.from(document.querySelectorAll(".final-gallery-item"));
      if (!modal || !modalImage || !items.length) return;

      let lastFocusedItem = null;

      function closeModal() {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        modalImage.removeAttribute("src");
        modalImage.alt = "";
        document.documentElement.classList.remove("lucy-final-gallery-open");
        if (lastFocusedItem) lastFocusedItem.focus();
      }

      function openModal(item) {
        const src = item.getAttribute("data-final-image-src");
        if (!src) return;

        lastFocusedItem = item;
        modalImage.src = src;
        modalImage.alt = item.getAttribute("data-final-image-alt") || "";
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("lucy-final-gallery-open");

        const closeButton = modal.querySelector(".final-gallery-modal-close");
        if (closeButton) closeButton.focus();
      }

      items.forEach((item) => {
        item.addEventListener("click", () => openModal(item));
      });

      modal.querySelectorAll("[data-final-gallery-close]").forEach((button) => {
        button.addEventListener("click", closeModal);
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && modal.classList.contains("is-open")) {
          closeModal();
        }
      });
    }

    function setStatus(message) {
      if (statusLabel) statusLabel.textContent = String(message || "");
    }

    function addDiagnostic(message) {
      const msg = String(message || "");
      diagnostics.unshift(msg);
      if (diagnostics.length > 8) diagnostics.length = 8;
      if (statusLabel) {
        statusLabel.textContent = diagnostics[0];
      }
      if (diagLabel) diagLabel.textContent = diagnostics[0];
    }

    function setCartLog(message, data) {
      const msg = String(message || "");
      if (cartLogLabel) cartLogLabel.textContent = msg;
      if (typeof console !== "undefined") {
        if (data !== undefined) {
          console.log(`[Lucy cart] ${msg}`, data);
        } else {
          console.log(`[Lucy cart] ${msg}`);
        }
      }
    }

    function syncCheckoutAvailability() {
      if (addToCartBtn) {
        addToCartBtn.disabled = !checkoutEnabled;
        addToCartBtn.setAttribute("aria-disabled", checkoutEnabled ? "false" : "true");
        if (checkoutEnabled) {
          addToCartBtn.removeAttribute("aria-describedby");
        } else {
          addToCartBtn.setAttribute("aria-describedby", "checkoutDevelopmentMessage");
        }
      }
      if (checkoutDevelopmentMessage) checkoutDevelopmentMessage.hidden = checkoutEnabled;
      if (checkoutWhatsapp) checkoutWhatsapp.hidden = checkoutEnabled;
    }

    function encodeBase64Utf8(str) {
      try {
        return btoa(unescape(encodeURIComponent(String(str || ""))));
      } catch (_) {
        return "";
      }
    }

    function validatePricingConfig() {
      const requiredWidths = [50, 75, 100, 125, 150, 200, 250, 300];
      const missingBase = requiredWidths.filter((w) => !Number(BASE_VARIANT_BY_WIDTH_CM[w]));
      const requiredAdj = ADJUSTMENT_DENOMS;
      const missingAdj = requiredAdj.filter((v) => !Number(ADJUSTMENT_VARIANT_BY_EUR[v]));
      if (missingBase.length) addDiagnostic(`Faltan IDs de variantes base: ${missingBase.join(", ")}`);
      if (missingAdj.length) addDiagnostic(`Faltan IDs de ajustes: ${missingAdj.join(", ")}`);
    }

    function charsPerLineLimitForWidth(widthCm) {
      const exact = SIZE_CHAR_LIMITS[widthCm];
      if (Number.isFinite(exact)) return exact;
      const stepped = 10 + Math.floor((widthCm - 50) / 25) * 3;
      return Math.max(1, stepped);
    }

    function textLineCharDemand() {
      const raw = document.getElementById("textInput").value || "";
      return raw
        .split("\n")
        .reduce((mx, line) => Math.max(mx, line.length), 0);
    }

    function dimensionsForWidth(widthCm, aspect = state.textAspect) {
      const safeAspect = Number(aspect);
      if (!Number.isFinite(safeAspect) || safeAspect <= 0) return null;
      return { widthCm, heightCm: widthCm / safeAspect };
    }

    function fitsBoardForWidth(widthCm, aspect = state.textAspect) {
      const dimensions = dimensionsForWidth(widthCm, aspect);
      if (!dimensions) return true;
      const { heightCm } = dimensions;
      const fitsLandscape = widthCm <= BOARD_LONG_SIDE_CM && heightCm <= BOARD_SHORT_SIDE_CM;
      const fitsPortrait = widthCm <= BOARD_SHORT_SIDE_CM && heightCm <= BOARD_LONG_SIDE_CM;
      return fitsLandscape || fitsPortrait;
    }

    function pickWidthForDemand(charDemand, aspect = state.textAspect) {
      const widths = sizeChips
        .map((btn) => parseFloat(btn.dataset.wcm))
        .filter((v) => Number.isFinite(v))
        .sort((a, b) => a - b);
      for (const w of widths) {
        if (charDemand <= charsPerLineLimitForWidth(w) && fitsBoardForWidth(w, aspect)) return w;
      }
      return null;
    }

    function syncSizeUiForTextDemand(aspect = state.textAspect) {
      const demand = textLineCharDemand();
      const requiredWidth = pickWidthForDemand(demand, aspect);
      const maxWidth = Math.max(...sizeChips.map((btn) => parseFloat(btn.dataset.wcm) || 0));
      const availableWidths = [];

      sizeChips.forEach((btn) => {
        const w = parseFloat(btn.dataset.wcm) || 0;
        const limit = charsPerLineLimitForWidth(w);
        const blockedByText = demand > limit;
        const blockedByBoard = !fitsBoardForWidth(w, aspect);
        const blocked = blockedByText || blockedByBoard;
        btn.classList.toggle("disabled", blocked);
        btn.disabled = blocked;
        btn.setAttribute("aria-disabled", blocked ? "true" : "false");
        if (blocked) {
          btn.title = blockedByBoard
            ? `Este tamaño no cabe en el tablero de ${BOARD_SHORT_SIDE_CM} × ${BOARD_LONG_SIDE_CM} cm.`
            : "";
        } else {
          btn.title = "";
          availableWidths.push(w);
        }
      });

      if (requiredWidth && state.selectedWidthCm < requiredWidth) {
        state.selectedWidthCm = requiredWidth;
      }

      if (!availableWidths.includes(state.selectedWidthCm) && availableWidths.length) {
        const notLargerThanSelection = availableWidths.filter((w) => w <= state.selectedWidthCm);
        state.selectedWidthCm = notLargerThanSelection.length
          ? Math.max(...notLargerThanSelection)
          : Math.min(...availableWidths);
      }

      sizeChips.forEach((b) => b.classList.toggle("active", (parseFloat(b.dataset.wcm) || 0) === state.selectedWidthCm));

      if (!requiredWidth && demand > charsPerLineLimitForWidth(maxWidth)) {
        setStatus(`Una sola línea es demasiado larga incluso para ${maxWidth} cm. Añade un salto de línea para que encaje.`);
      }
    }

    function fontCandidates(name) {
      const primary = fontAssetMap[name];
      const lower = name.toLowerCase();
      const candidates = [
        `assets/fonts/${name}.ttf`,
        `assets/fonts/${lower}.ttf`,
        `fonts/${name}/${name}.ttf`,
        `fonts/${name}/${lower}.ttf`,
        `fonts/${name}/font.ttf`,
        `fonts/${name}/font.otf`,
      ];
      if (primary) candidates.unshift(primary);
      return candidates;
    }

    function withCacheBust(url) {
      const sep = String(url).includes("?") ? "&" : "?";
      return `${url}${sep}t=${Date.now()}`;
    }

    async function loadFontByName(name) {
      if (fontCache.has(name)) return fontCache.get(name);
      let lastErr = null;

      for (const url of fontCandidates(name)) {
        try {
          const res = await fetch(withCacheBust(url), { cache: "no-store" });
          if (!res.ok) continue;
          const buf = await res.arrayBuffer();
          let font = null;
          try {
            font = opentype.parse(buf);
          } catch (parseErr) {
            const family = await loadPreviewFontFamily(name);
            const msg = String(parseErr && parseErr.message ? parseErr.message : parseErr || "");
            if (family && msg.includes("wOF2")) {
              addDiagnostic(`Fallback de OpenType para ${name}: usando modo de texto SVG (wOF2)`);
              const meta = { font: null, url, family, mode: "svg-text" };
              fontCache.set(name, meta);
              return meta;
            }
            throw parseErr;
          }
          const meta = { font, url, family: "", mode: "path" };
          fontCache.set(name, meta);
          return meta;
        } catch (err) {
          lastErr = err;
        }
      }
      throw new Error(`No se encontró una tipografía web para "${name}". Se probó: ${fontCandidates(name).join(", ")}${lastErr ? ` | ${String(lastErr)}` : ""}`);
    }

    function escapeXml(s) {
      return String(s || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&apos;");
    }

    function buildMultilineTextMetrics(text, fontSize, spacing, lineHeight) {
      const lines = String(text || "").split("\n");
      const lineAdvance = Math.max(1, lineHeight || fontSize * 0.95);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const ff = state.selectedFont ? `Preview_${state.selectedFont.replace(/\s+/g, "_")}` : "Poppins";
      ctx.font = `${fontSize}px "${ff}", "Poppins", sans-serif`;

      const widths = [];
      const lineAsc = [];
      const lineDesc = [];
      lines.forEach((line) => {
        const chars = Array.from(line || "");
        if (!chars.length) {
          widths.push(0);
          lineAsc.push(fontSize * 0.70);
          lineDesc.push(fontSize * 0.20);
          return;
        }
        let w = 0;
        chars.forEach((ch, idx) => {
          w += ctx.measureText(ch).width;
          if (idx < chars.length - 1) w += spacing;
        });
        const tm = ctx.measureText(line);
        const asc = Number.isFinite(tm.actualBoundingBoxAscent) && tm.actualBoundingBoxAscent > 0
          ? tm.actualBoundingBoxAscent
          : fontSize * 0.70;
        const desc = Number.isFinite(tm.actualBoundingBoxDescent) && tm.actualBoundingBoxDescent > 0
          ? tm.actualBoundingBoxDescent
          : fontSize * 0.20;
        widths.push(w);
        lineAsc.push(asc);
        lineDesc.push(desc);
      });
      const width = Math.max(1, ...widths);
      let minY = Number.POSITIVE_INFINITY;
      let maxY = Number.NEGATIVE_INFINITY;
      let baselineY = 0;
      for (let i = 0; i < lines.length; i += 1) {
        baselineY += lineAsc[i];
        minY = Math.min(minY, baselineY - lineAsc[i]);
        maxY = Math.max(maxY, baselineY + lineDesc[i]);
        baselineY += Math.max(0, lineAdvance - lineAsc[i] - lineDesc[i]);
      }
      const height = Math.max(1, maxY - minY);
      return {
        mode: "svg-text",
        lines,
        widths,
        lineAsc,
        lineDesc,
        width,
        height,
        minX: 0,
        minY,
        maxX: width,
        maxY,
        lineAdvance
      };
    }

    function activeRender() {
      return renderOptions.find((render) => render.id === state.selectedRenderId) || renderOptions[0];
    }

    function renderUrl(render = activeRender()) {
      return render?.src || fallbackMockupUrl;
    }

    function setMockupImage(render = activeRender()) {
      if (mockupBg) {
        mockupBg.src = renderUrl(render);
        mockupBg.alt = `Fondo del mockup: ${render?.label || "ambiente"}`;
      }
    }

    function loadMockupMeta(render = activeRender()) {
      const src = renderUrl(render);
      if (mockupMetaCache.has(src)) return Promise.resolve(mockupMetaCache.get(src));
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const meta = { width: img.naturalWidth || render?.width || 1, height: img.naturalHeight || render?.height || 1 };
          mockupMetaCache.set(src, meta);
          resolve(meta);
        };
        img.onerror = () => {
          const meta = { width: render?.width || 1, height: render?.height || 1 };
          mockupMetaCache.set(src, meta);
          resolve(meta);
        };
        img.src = src;
      });
    }

    function imageRectWithinViewer(meta) {
      const rect = viewer?.getBoundingClientRect();
      if (!rect || !rect.width || !rect.height) {
        return { x: 0, y: 0, width: 1, height: 1 };
      }

      const imageAspect = (meta?.width || 1) / Math.max(1, meta?.height || 1);
      const viewerAspect = rect.width / Math.max(1, rect.height);
      const mobilePreview = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
      const fitMode = mobilePreview ? "cover" : "contain";
      const visualScale = mobilePreview ? 1.02 : 1;
      let width = rect.width;
      let height = rect.height;
      let x = 0;
      let y = 0;

      if ((fitMode === "contain" && imageAspect > viewerAspect) || (fitMode === "cover" && imageAspect < viewerAspect)) {
        height = rect.width / imageAspect;
        y = (rect.height - height) * 0.5;
      } else {
        width = rect.height * imageAspect;
        x = (rect.width - width) * 0.5;
      }

      if (visualScale !== 1) {
        const scaledWidth = width * visualScale;
        const scaledHeight = height * visualScale;
        x -= (scaledWidth - width) * 0.5;
        y -= (scaledHeight - height) * 0.5;
        width = scaledWidth;
        height = scaledHeight;
      }

      return { x, y, width, height };
    }

    function planeToDisplayQuad(render, meta) {
      const rect = imageRectWithinViewer(meta);
      const fallbackPlane = renderOptions[0]?.plane || {};
      const plane = render?.plane || fallbackPlane;
      const point = (key) => {
        const p = plane[key] || fallbackPlane[key] || { x: 0, y: 0 };
        return {
          x: rect.x + rect.width * Number(p.x || 0),
          y: rect.y + rect.height * Number(p.y || 0)
        };
      };
      return {
        tl: point("tl"),
        tr: point("tr"),
        br: point("br"),
        bl: point("bl")
      };
    }

    function quadBounds(quad) {
      const points = [quad.tl, quad.tr, quad.br, quad.bl];
      const xs = points.map((p) => p.x);
      const ys = points.map((p) => p.y);
      const left = Math.min(...xs);
      const top = Math.min(...ys);
      const right = Math.max(...xs);
      const bottom = Math.max(...ys);
      return {
        left,
        top,
        width: Math.max(1, right - left),
        height: Math.max(1, bottom - top)
      };
    }

    function matrix3dForQuad(width, height, quad) {
      const points = [quad.tl, quad.tr, quad.br, quad.bl];
      const x0 = points[0].x, y0 = points[0].y;
      const x1 = points[1].x, y1 = points[1].y;
      const x2 = points[2].x, y2 = points[2].y;
      const x3 = points[3].x, y3 = points[3].y;
      const dx1 = x1 - x2;
      const dy1 = y1 - y2;
      const dx2 = x3 - x2;
      const dy2 = y3 - y2;
      const sx = x0 - x1 + x2 - x3;
      const sy = y0 - y1 + y2 - y3;
      const denom = dx1 * dy2 - dx2 * dy1;
      let g = 0;
      let hh = 0;
      if (Math.abs(denom) > 0.000001) {
        g = (sx * dy2 - dx2 * sy) / denom;
        hh = (dx1 * sy - sx * dy1) / denom;
      }
      const a = x1 - x0 + g * x1;
      const b = x3 - x0 + hh * x3;
      const c = x0;
      const d = y1 - y0 + g * y1;
      const e = y3 - y0 + hh * y3;
      const f = y0;
      const w = Math.max(1, width);
      const h = Math.max(1, height);
      const values = [
        a / w, d / w, 0, g / w,
        b / h, e / h, 0, hh / h,
        0, 0, 1, 0,
        c, f, 0, 1
      ];
      return `matrix3d(${values.map((value) => Number(value).toFixed(10)).join(",")})`;
    }

    function applyPlaneTransform(render, meta) {
      if (!svgShell) return null;
      const quad = planeToDisplayQuad(render, meta);
      const bounds = quadBounds(quad);
      const relativeQuad = {
        tl: { x: quad.tl.x - bounds.left, y: quad.tl.y - bounds.top },
        tr: { x: quad.tr.x - bounds.left, y: quad.tr.y - bounds.top },
        br: { x: quad.br.x - bounds.left, y: quad.br.y - bounds.top },
        bl: { x: quad.bl.x - bounds.left, y: quad.bl.y - bounds.top }
      };
      svgShell.style.left = `${bounds.left}px`;
      svgShell.style.top = `${bounds.top}px`;
      svgShell.style.width = `${bounds.width}px`;
      svgShell.style.height = `${bounds.height}px`;
      svgShell.style.setProperty("--plane-transform", matrix3dForQuad(bounds.width, bounds.height, relativeQuad));
      return bounds;
    }

    function renderRenderSwitcher() {
      if (!renderSwitcher) return;
      renderSwitcher.innerHTML = "";
      renderOptions.forEach((render) => {
        const button = document.createElement("button");
        button.type = "button";
        button.dataset.renderId = render.id;
        button.className = render.id === state.selectedRenderId ? "active" : "";
        button.setAttribute("aria-label", `Ver en ${render.label || render.id}`);
        button.setAttribute("aria-pressed", render.id === state.selectedRenderId ? "true" : "false");
        button.innerHTML = `
          <img src="${renderUrl(render)}" alt="" loading="lazy">
          <span>${escapeXml(render.label || render.id)}</span>
        `;
        button.addEventListener("click", () => selectRender(render));
        renderSwitcher.appendChild(button);
      });
    }

    function updateRenderSwitcherState(render = activeRender()) {
      if (!renderSwitcher || !render) return;
      renderSwitcher.querySelectorAll("button").forEach((btn) => {
        const active = btn.dataset.renderId === render.id;
        btn.classList.toggle("active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function selectRender(render, options = {}) {
      if (!render) return Promise.resolve();
      const changed = state.selectedRenderId !== render.id;
      state.selectedRenderId = render.id;
      updateRenderSwitcherState(render);
      if (!options.skipImage) setMockupImage(render);
      return changed || options.forceApply ? applyChanges() : Promise.resolve();
    }

    function selectAdjacentRender(direction) {
      const current = renderOptions.findIndex((render) => render.id === state.selectedRenderId);
      if (current < 0 || !renderOptions.length) return;
      const nextIndex = (current + direction + renderOptions.length) % renderOptions.length;
      const nextRender = renderOptions[nextIndex];
      selectRender(nextRender);
    }

    function initRenderSwipe() {
      if (!viewer || renderOptions.length < 2 || !mockupBg) return;
      const mobileQuery = window.matchMedia ? window.matchMedia("(max-width: 749px)") : null;
      let startX = 0;
      let startY = 0;
      let startTime = 0;
      let dragX = 0;
      let dragging = false;
      let swipeDirection = 0;
      let adjacentRender = null;
      let adjacentImage = null;

      function isMobileSwipe() {
        return !mobileQuery || mobileQuery.matches;
      }

      function resetSwipeStyles() {
        viewer.classList.remove("is-swiping", "is-swipe-settling");
        mockupBg.style.transform = "";
        if (viewerStage) viewerStage.style.transform = "";
        if (adjacentImage) {
          adjacentImage.remove();
          adjacentImage = null;
        }
        adjacentRender = null;
        dragging = false;
        swipeDirection = 0;
        dragX = 0;
      }

      function adjacentForDirection(direction) {
        const current = renderOptions.findIndex((render) => render.id === state.selectedRenderId);
        if (current < 0) return null;
        const nextIndex = (current + direction + renderOptions.length) % renderOptions.length;
        return renderOptions[nextIndex] || null;
      }

      function ensureAdjacentImage(direction) {
        const nextRender = adjacentForDirection(direction);
        if (!nextRender) return null;
        if (adjacentRender?.id === nextRender.id && adjacentImage) return adjacentImage;
        if (adjacentImage) adjacentImage.remove();
        adjacentRender = nextRender;
        adjacentImage = document.createElement("img");
        adjacentImage.className = "mockup-bg swipe-mockup";
        adjacentImage.src = renderUrl(nextRender);
        adjacentImage.alt = "";
        viewer.insertBefore(adjacentImage, viewerStage || renderSwitcher || null);
        return adjacentImage;
      }

      function imageTransform(x) {
        return `translateX(${Math.round(x)}px) scale(1.02)`;
      }

      function applySwipeOffset(x) {
        const width = Math.max(1, viewer.getBoundingClientRect().width || 1);
        const direction = x < 0 ? 1 : -1;
        const nextImage = ensureAdjacentImage(direction);
        if (!nextImage) return;
        swipeDirection = direction;
        dragX = x;
        mockupBg.style.transform = imageTransform(x);
        if (viewerStage) viewerStage.style.transform = `translateX(${Math.round(x)}px)`;
        const nextX = direction > 0 ? width + x : -width + x;
        nextImage.style.transform = imageTransform(nextX);
      }

      function settleSwipe(commit) {
        const width = Math.max(1, viewer.getBoundingClientRect().width || 1);
        const direction = swipeDirection || (dragX < 0 ? 1 : -1);
        const currentTarget = commit ? -direction * width : 0;
        const nextTarget = commit ? 0 : (direction > 0 ? width : -width);
        viewer.classList.remove("is-swiping");
        viewer.classList.add("is-swipe-settling");
        mockupBg.style.transform = imageTransform(currentTarget);
        if (viewerStage) viewerStage.style.transform = `translateX(${Math.round(currentTarget)}px)`;
        if (adjacentImage) adjacentImage.style.transform = imageTransform(nextTarget);

        window.setTimeout(() => {
          const renderToSelect = commit ? adjacentRender : null;
          resetSwipeStyles();
          if (renderToSelect) selectRender(renderToSelect);
        }, 260);
      }

      viewer.addEventListener("touchstart", (event) => {
        if (!isMobileSwipe()) return;
        const touch = event.touches && event.touches[0];
        if (!touch) return;
        resetSwipeStyles();
        startX = touch.clientX;
        startY = touch.clientY;
        startTime = Date.now();
      }, { passive: true });

      viewer.addEventListener("touchmove", (event) => {
        if (!isMobileSwipe() || !startTime) return;
        const touch = event.touches && event.touches[0];
        if (!touch) return;
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        if (!dragging) {
          if (Math.abs(dx) < 10) return;
          if (Math.abs(dx) < Math.abs(dy) * 1.2) return;
          dragging = true;
          viewer.classList.add("is-swiping");
        }
        event.preventDefault();
        const width = Math.max(1, viewer.getBoundingClientRect().width || 1);
        const resistance = Math.min(width * 0.92, Math.max(-width * 0.92, dx));
        applySwipeOffset(resistance);
      }, { passive: false });

      viewer.addEventListener("touchend", (event) => {
        if (!isMobileSwipe()) return;
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch || !startTime) return;
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        const elapsed = Date.now() - startTime;
        startTime = 0;
        if (!dragging) {
          if (elapsed <= 650 && Math.abs(dx) >= 44 && Math.abs(dx) >= Math.abs(dy) * 1.35) {
            selectAdjacentRender(dx < 0 ? 1 : -1);
          }
          resetSwipeStyles();
          return;
        }
        const width = Math.max(1, viewer.getBoundingClientRect().width || 1);
        const shouldCommit = elapsed <= 900 && Math.abs(dx) > Math.min(110, width * 0.28) && Math.abs(dx) >= Math.abs(dy) * 1.05;
        settleSwipe(shouldCommit);
      }, { passive: true });

      viewer.addEventListener("touchcancel", () => {
        if (dragging) settleSwipe(false);
        else resetSwipeStyles();
      }, { passive: true });
    }

    async function loadPreviewFontFamily(name) {
      if (previewFontCache.has(name)) return previewFontCache.get(name);
      const family = `Preview_${name.replace(/\s+/g, "_")}`;
      for (const url of fontCandidates(name)) {
        try {
          const ff = new FontFace(family, `url(${url})`);
          await ff.load();
          document.fonts.add(ff);
          previewFontCache.set(name, family);
          return family;
        } catch (_) {
          // try next candidate
        }
      }
      previewFontCache.set(name, "");
      return "";
    }

    function loadHighlightsMeta() {
      if (highlightMeta) return Promise.resolve(highlightMeta);
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          highlightMeta = { image: img, width: img.naturalWidth || 1, height: img.naturalHeight || 1 };
          resolve(highlightMeta);
        };
        img.onerror = () => {
          highlightMeta = { image: null, width: 1, height: 1 };
          resolve(highlightMeta);
        };
        img.src = highlightsUrl;
      });
    }

    async function buildTintedHighlightDataUrl(hex) {
      const key = `${hex}|${HIGHLIGHT_CFG.strength}|${HIGHLIGHT_CFG.gamma}|${HIGHLIGHT_CFG.threshold}|${HIGHLIGHT_CFG.invert ? 1 : 0}`;
      if (highlightTintCache.has(key)) return highlightTintCache.get(key);

      const meta = await loadHighlightsMeta();
      if (!meta.image) return "";

      const canvas = document.createElement("canvas");
      canvas.width = meta.width;
      canvas.height = meta.height;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      if (!ctx) return "";

      ctx.drawImage(meta.image, 0, 0);
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const d = imgData.data;
      const { r: cr, g: cg, b: cb } = hexToRgb(hex);
      const strength = HIGHLIGHT_CFG.strength;
      const gamma = HIGHLIGHT_CFG.gamma;
      const thr = HIGHLIGHT_CFG.threshold;
      const inv = HIGHLIGHT_CFG.invert;

      for (let i = 0; i < d.length; i += 4) {
        let v = Math.round(0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]); // luminance
        if (inv) v = 255 - v;
        if (v <= thr) {
          d[i] = 0; d[i + 1] = 0; d[i + 2] = 0; d[i + 3] = 255;
          continue;
        }
        let t = v / 255;
        t = Math.pow(t, gamma);
        t = Math.min(1, t * strength);
        d[i] = Math.round(cr * t);
        d[i + 1] = Math.round(cg * t);
        d[i + 2] = Math.round(cb * t);
        d[i + 3] = 255; // opaque, like desktop
      }

      ctx.putImageData(imgData, 0, 0);
      const url = canvas.toDataURL("image/png");
      highlightTintCache.set(key, url);
      return url;
    }

    function renderFonts() {
      fontGrid.innerHTML = "";
      fonts.forEach((name, idx) => {
        const card = document.createElement("button");
        card.className = "font-card" + (name === state.selectedFont ? " active" : "");
        card.innerHTML = `
          <div class="thumb" aria-hidden="true">Aa</div>
          <div>${name}</div>
        `;
        card.onclick = async () => {
          document.querySelectorAll(".font-card").forEach(c => c.classList.remove("active"));
          card.classList.add("active");
          state.selectedFont = name;
          await applyChanges();
        };
        fontGrid.appendChild(card);
        const thumb = card.querySelector(".thumb");
        loadPreviewFontFamily(name).then((family) => {
          if (family && thumb) {
            thumb.style.fontFamily = `"${family}", "Poppins", "Segoe UI", sans-serif`;
          } else {
            addDiagnostic(`Falló la previsualización de la tipografía ${name}`);
          }
        });
      });
    }

    function renderSwatches() {
      swatches.innerHTML = "";
      swatchColors.forEach((hex, idx) => {
        const sw = document.createElement("button");
        sw.className = "swatch" + (idx === 0 ? " active" : "");
        sw.style.background = hex;
        sw.onclick = async () => {
          state.strokeColor = hex;
          document.querySelectorAll(".swatch").forEach(s => s.classList.remove("active"));
          sw.classList.add("active");
          await applyChanges();
        };
        swatches.appendChild(sw);
      });
    }

    function setView(view) {
      state.view = "render";
      viewer.classList.add("render");
    }

    function numberInput(id, fallback) {
      const v = parseFloat(document.getElementById(id).value);
      return Number.isFinite(v) ? v : fallback;
    }

    function currentLayoutDefaults() {
      return FONT_LAYOUT_DEFAULTS[state.selectedFont] || FALLBACK_LAYOUT_DEFAULTS;
    }

    function currentSpacing() {
      const layout = currentLayoutDefaults();
      return layout.spacing;
    }

    function currentLineHeight() {
      return currentLayoutDefaults().lineHeight;
    }

    function syncPreviewZoom() {
      if (!viewer) return;
      viewer.classList.remove("small-size-zoom");
    }

    function measuredNeonLengthCm(text, fontName, targetWidthCm) {
      const metrics = glyphMetricsMap[fontName];
      if (!metrics || !metrics.glyphs) return null;

      let totalLengthUnits = 0;
      const lineBounds = [];
      const lines = String(text || "").split("\n");

      for (const line of lines) {
        let cursorX = 0;
        let minX = Number.POSITIVE_INFINITY;
        let maxX = Number.NEGATIVE_INFINITY;
        let previousChar = null;

        for (const char of Array.from(line)) {
          if (/\s/.test(char)) {
            cursorX += Number(metrics.space || 120);
            previousChar = null;
            continue;
          }

          const glyph = metrics.glyphs[char]
            || metrics.glyphs[char.toLowerCase()]
            || metrics.glyphs[char.toUpperCase()];
          if (!glyph) return null;

          const pairRow = previousChar ? metrics.pairs?.[previousChar] : null;
          const kerning = Number(pairRow?.[char] || 0) * Number(metrics.kerningScale || 1);
          const glyphX = cursorX + Number(glyph.o || 0) + kerning;
          const glyphWidth = Number(glyph.w || 0);
          minX = Math.min(minX, glyphX);
          maxX = Math.max(maxX, glyphX + glyphWidth);
          totalLengthUnits += Number(glyph.l || 0);

          const configuredAdvance = Number(glyph.a || 0);
          const advance = configuredAdvance > 0
            ? configuredAdvance
            : glyphWidth + Number(metrics.spacing || 0);
          cursorX += advance + Number(glyph.n || 0) + kerning;
          previousChar = char;
        }

        if (Number.isFinite(minX) && Number.isFinite(maxX)) {
          lineBounds.push({ minX, maxX });
        }
      }

      if (!lineBounds.length || totalLengthUnits <= 0) return 0;

      // Match Lucy desktop's composed SVG: glyph bounds plus 50 units of padding per side.
      const widest = lineBounds.reduce((best, bounds) => {
        const documentWidth = bounds.maxX - Math.min(bounds.minX, 0) + 100;
        return Math.max(best, documentWidth);
      }, 0);
      if (widest <= 0) return null;

      const scaleToPhysicalMm = (Number(targetWidthCm) * 10) / widest;
      return (totalLengthUnits * scaleToPhysicalMm) / 10;
    }

    function computePricingEstimate() {
      const widthMm = (state.selectedWidthCm || 100) * 10;
      const heightMm = numberInput("hInput", 500);
      const widthCm = widthMm / 10;
      const heightCm = heightMm / 10;

      const textRaw = (document.getElementById("textInput").value || "");
      const litChars = textRaw.replace(/\s+/g, "").length;
      const effectiveChars = litChars > 0 ? Math.pow(litChars, PRICE_CFG.fallbackCharExponent) : 0;
      const measuredLength = measuredNeonLengthCm(textRaw, state.selectedFont, widthCm);
      const neonLengthCm = Number.isFinite(measuredLength)
        ? measuredLength
        : effectiveChars * PRICE_CFG.fallbackCmPerCharAt100cm * (widthCm / 100);

      const areaPrice = (widthCm * heightCm / 10000) * PRICE_CFG.areaRatePerM2;
      const neonPrice = neonLengthCm * PRICE_CFG.neonRatePerCm;
      const laborPrice = litChars * PRICE_CFG.laborRatePerCharacter;
      const rawTotal = areaPrice + neonPrice + laborPrice;
      const total = rawTotal;

      return {
        neonLengthCm,
        total,
        rawTotal,
        areaPrice,
        neonPrice,
        laborPrice,
        widthCm,
        heightCm,
        litChars,
        effectiveChars,
        measured: Number.isFinite(measuredLength)
      };
    }

    function computeCheckoutCharge(targetTotalEur) {
      const adjustmentTotal = Math.max(0, Math.ceil((targetTotalEur || 0) - BASE_PRICE_EUR));
      const chargedTotal = BASE_PRICE_EUR + adjustmentTotal;
      return { adjustmentTotal, chargedTotal };
    }

    function selectedBaseVariantId() {
      const w = Math.round(state.selectedWidthCm || 100);
      const id = BASE_VARIANT_BY_WIDTH_CM[w] || BASE_VARIANT_BY_WIDTH_CM[100];
      if (!id) throw new Error(`No base variant ID configured for width ${w}`);
      return id;
    }

    function buildAdjustmentLines(deltaEur, sharedProps) {
      let remaining = Math.max(0, Math.ceil(deltaEur));
      const lines = [];
      for (const denom of ADJUSTMENT_DENOMS) {
        if (remaining < denom) continue;
        const variantId = ADJUSTMENT_VARIANT_BY_EUR[denom];
        if (!variantId) {
          addDiagnostic(`Falta el ID de la variante de ajuste de ${denom} €`);
          continue;
        }
        const quantity = Math.floor(remaining / denom);
        remaining -= quantity * denom;
        lines.push({
          id: variantId,
          quantity,
          properties: {
            ...sharedProps,
            _component: "adjustment",
            _adjustment_eur: String(denom)
          }
        });
      }
      return lines;
    }

    function buildCartItems() {
      const quote = computePricingEstimate();
      const configId = `cfg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      const baseVariantId = selectedBaseVariantId();
      const targetTotal = Number(quote.total.toFixed(2));
      const charge = computeCheckoutCharge(targetTotal);
      const deltaEur = charge.adjustmentTotal;
      const alignEs = state.align === "left"
        ? "izquierda"
        : (state.align === "center" ? "centrado" : "derecha");
      const widthCm = Math.round(state.selectedWidthCm || 100);
      const heightCm = Number(numberInput("hInput", 500) / 10).toFixed(1);

      const sharedProps = {
        _config_id: configId,
        _pricing_version: PRICING_VERSION,
        _font: state.selectedFont,
        _color: state.strokeColor,
        _align: state.align,
        _width_cm: String(widthCm),
        _height_cm: String(heightCm)
      };

      const text = (document.getElementById("textInput").value || "").trim();
      const safeText = text.replace(/\r/g, "");
      const cfgManifest = [
        `v=${PRICING_VERSION}`,
        `id=${configId}`,
        `font=${state.selectedFont}`,
        `color=${state.strokeColor}`,
        `align=${state.align}`,
        `w=${widthCm}`,
        `h=${heightCm}`,
        `price=${charge.chargedTotal.toFixed(2)}`
      ].join("|");
      const payload = JSON.stringify({
        pricing_version: PRICING_VERSION,
        target_total_eur: targetTotal,
        charged_total_eur: charge.chargedTotal,
        quote_eur: quote.rawTotal,
        floor_eur: 0,
        text: safeText,
        font: state.selectedFont,
        color: state.strokeColor,
        align: state.align,
        width_cm: widthCm,
        height_cm: heightCm
      });
      const payloadB64 = encodeBase64Utf8(payload);
      const readableEsProps = {
        "Texto": safeText || "(vacío)",
        "Fuente": state.selectedFont,
        "Color": state.strokeColor,
        "Alineación": alignEs,
        "Ancho (cm)": String(widthCm),
        "Alto (cm)": String(heightCm),
        "Precio final (€)": charge.chargedTotal.toFixed(2)
      };

      const baseItem = {
        id: baseVariantId,
        quantity: 1,
        properties: {
          ...readableEsProps,
          ...sharedProps,
          _component: "base",
          _charged_total_eur: charge.chargedTotal.toFixed(2),
          _cfg_manifest: cfgManifest,
          _cfg_text: safeText,
          _customizer_payload: payload,
          _desktop_cfg_v1: payloadB64
        }
      };
      const adjustmentItems = buildAdjustmentLines(deltaEur, sharedProps).map((line) => ({
        ...line,
        // Make adjustment lines children of the base item.
        parent_id: baseVariantId
      }));

      const items = [baseItem, ...adjustmentItems];
      if (!items.length) throw new Error("No se generaron líneas de carrito con la configuración actual");
      return items;
    }

    async function addConfiguredSignToCart() {
      if (!checkoutEnabled) {
        setStatus("La compra online todavía está desactivada.");
        return;
      }
      const btn = addToCartBtn;
      if (!btn) return;
      const btnLabel = btn.querySelector(".checkout-cta-label");
      btn.disabled = true;
      btnLabel.textContent = "Añadiendo...";
      try {
        setStatus("Añadiendo el rótulo configurado al carrito...");
        await applyChanges();
        const items = buildCartItems();
        const configId = items?.[0]?.properties?._config_id || "faltante";
        const expectedLines = items.length;
        const expectedQty = items.reduce((n, it) => n + Number(it.quantity || 0), 0);
        setCartLog(`Preparadas ${expectedLines} línea(s), cantidad ${expectedQty}, cfg ${configId}`, items.map((it) => ({ id: it.id, q: it.quantity, comp: it.properties?._component, adj: it.properties?._adjustment_eur, parent_id: it.parent_id || null })));
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ items })
        });
        setCartLog(`POST /cart/add.js -> ${res.status}`);
        if (!res.ok) {
          const t = await res.text();
          setCartLog(`add.js body: ${t.slice(0, 300)}`);
          throw new Error(`Error del carrito: ${res.status} ${t}`);
        }
        const cartRes = await fetch("/cart.js", {
          method: "GET",
          headers: { "Accept": "application/json" },
          credentials: "same-origin"
        });
        if (!cartRes.ok) throw new Error(`Falló la verificación del carrito: ${cartRes.status}`);
        const cart = await cartRes.json();
        const cfgLines = Array.isArray(cart.items)
          ? cart.items.filter((it) => it?.properties?._config_id === configId)
          : [];
        const cfgQty = cfgLines.reduce((n, it) => n + Number(it.quantity || 0), 0);
        setCartLog(`Verificación cfg ${configId}: ${cfgLines.length} línea(s), cantidad ${cfgQty}`);
        if (cfgLines.length === 0) {
          throw new Error(`Falló la verificación del carrito: no se encontraron líneas para cfg ${configId}`);
        }
        setStatus(`Añadido al carrito. Artículos en el carrito: ${Number(cart.item_count || 0)}`);
        window.location.href = "/cart";
      } catch (err) {
        addDiagnostic(`Falló al añadir al carrito: ${String(err.message || err)}`);
        setCartLog(`ERROR: ${String(err.message || err)}`);
      } finally {
        btn.disabled = !checkoutEnabled;
        btn.setAttribute("aria-disabled", checkoutEnabled ? "false" : "true");
        btnLabel.textContent = "Añadir a la cesta";
      }
    }

    function clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    }

    function hexToRgb(hex) {
      const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec((hex || "").trim());
      if (!m) return { r: 255, g: 255, b: 255 };
      return {
        r: parseInt(m[1], 16),
        g: parseInt(m[2], 16),
        b: parseInt(m[3], 16),
      };
    }

    function rgbToHsl(r, g, b) {
      const rn = r / 255, gn = g / 255, bn = b / 255;
      const max = Math.max(rn, gn, bn), min = Math.min(rn, gn, bn);
      let h = 0, s = 0;
      const l = (max + min) / 2;
      if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case rn: h = (gn - bn) / d + (gn < bn ? 6 : 0); break;
          case gn: h = (bn - rn) / d + 2; break;
          default: h = (rn - gn) / d + 4; break;
        }
        h /= 6;
      }
      return { h, s, l };
    }

    function hslToRgb(h, s, l) {
      let r, g, b;
      if (s === 0) {
        r = g = b = l;
      } else {
        const hue2rgb = (p, q, t) => {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
      };
    }

    function softTubeColor(hex) {
      const { r, g, b } = hexToRgb(hex);
      const hsl = rgbToHsl(r, g, b);
      // Keep hue but keep some saturation so tube still looks neon-bright.
      const s = clamp(hsl.s * 0.48, 0.14, 0.62);
      const l = clamp(Math.max(hsl.l, 0.80), 0, 1);
      return hslToRgb(hsl.h, s, l);
    }

    function extraStrokeForWidth(widthCm) {
      const w = clamp(Number(widthCm) || 300, 50, 300);
      const t = (300 - w) / 250;
      return 1.45 * Math.pow(t, 1.25);
    }

    function buildMultilinePath(font, text, fontSize, spacing, lineHeight, align) {
      const lines = (text || "").split("\n");
      const lineData = [];
      let maxWidth = 0;
      let totalPath = "";
      let minX = Infinity;
      let minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;

      for (const line of lines) {
        const glyphs = font.stringToGlyphs(line);
        let x = 0;
        let prev = null;
        const placements = [];

        for (const glyph of glyphs) {
          if (!glyph) continue;
          if (prev) x += font.getKerningValue(prev, glyph) * (fontSize / font.unitsPerEm);
          placements.push({ glyph, x });
          x += (glyph.advanceWidth || 0) * (fontSize / font.unitsPerEm) + spacing;
          prev = glyph;
        }
        lineData.push({ line, placements, width: x });
        maxWidth = Math.max(maxWidth, x);
      }

      lineData.forEach((ln, idx) => {
        let startX = 0;
        if (align === "center") startX = (maxWidth - ln.width) / 2;
        if (align === "right") startX = (maxWidth - ln.width);
        const y = fontSize + idx * lineHeight;
        for (const gp of ln.placements) {
          const p = gp.glyph.getPath(startX + gp.x, y, fontSize);
          totalPath += p.toPathData(4) + " ";
          const bb = p.getBoundingBox();
          if (Number.isFinite(bb.x1) && Number.isFinite(bb.y1) && Number.isFinite(bb.x2) && Number.isFinite(bb.y2)) {
            minX = Math.min(minX, bb.x1);
            minY = Math.min(minY, bb.y1);
            maxX = Math.max(maxX, bb.x2);
            maxY = Math.max(maxY, bb.y2);
          }
        }
      });

      if (!Number.isFinite(minX) || !Number.isFinite(minY) || !Number.isFinite(maxX) || !Number.isFinite(maxY)) {
        minX = 0; minY = 0; maxX = Math.max(1, maxWidth); maxY = Math.max(1, fontSize);
      }
      const width = Math.max(1, maxX - minX);
      const height = Math.max(1, maxY - minY);
      return { d: totalPath.trim(), width, height, minX, minY, maxX, maxY };
    }

    function syncHeightFromWidth() {
      if (!state.textAspect || state.textAspect <= 0) return;
      const w = (state.selectedWidthCm || 100) * 10;
      const minHeightMm = MIN_HEIGHT_CM * 10;
      const h = Math.max(minHeightMm, w / state.textAspect);
      state.dimSyncing = true;
      document.getElementById("wInput").value = w.toFixed(1);
      document.getElementById("hInput").value = h.toFixed(1);
      state.dimSyncing = false;
    }

    function syncWidthFromHeight() {
      if (!state.textAspect || state.textAspect <= 0) return;
      const minHeightMm = MIN_HEIGHT_CM * 10;
      const h = Math.max(minHeightMm, numberInput("hInput", 500));
      const w = h * state.textAspect;
      state.dimSyncing = true;
      document.getElementById("wInput").value = w.toFixed(1);
      document.getElementById("hInput").value = h.toFixed(1);
      state.dimSyncing = false;
    }

    async function applyChanges(dimSource = "auto") {
      setStatus("Construyendo geometría...");
      syncPreviewZoom();
      try {
        const render = activeRender();
        setMockupImage(render);
        const [{ font, url, family, mode }, mockup] = await Promise.all([
          loadFontByName(state.selectedFont),
          loadMockupMeta(render)
        ]);
        const text = document.getElementById("textInput").value || "Texto";
        const lineHeight = currentLineHeight();
        const spacing = currentSpacing();
        let svgMarkup = "";
        let pathLength = 0;
        const fontSize = 140;
        const built = (mode === "svg-text" || !font)
          ? buildMultilineTextMetrics(text, fontSize, spacing, lineHeight)
          : buildMultilinePath(font, text, fontSize, spacing, lineHeight, state.align);
        const planeBounds = applyPlaneTransform(render, mockup) || { width: 1, height: 1 };
        const vbW = 1000;
        const vbH = clamp(vbW * (planeBounds.height / Math.max(1, planeBounds.width)), 360, 1250);
        const framePad = 54;
        const pathD = built.d;
        state.textAspect = built.width / Math.max(1, built.height);
        syncSizeUiForTextDemand(state.textAspect);
        const redStrokePx = 0;
        const coreStrokePx = extraStrokeForWidth(state.selectedWidthCm);
        const widthCm = (numberInput("wInput", 1200) / 10).toFixed(2);
        const heightCm = (numberInput("hInput", 500) / 10).toFixed(2);

        if (!state.dimSyncing) {
          if (dimSource === "h") {
            syncWidthFromHeight();
          } else {
            syncHeightFromWidth();
          }
        }

        // Fit geometry to the visible frame with consistent inner padding.
        const fitW = Math.max(1, vbW - framePad * 2);
        const fitH = Math.max(1, vbH - framePad * 2);

        const sceneWidthCm = Math.max(1, Number(render.sceneWidthCm) || TEXT_LAYOUT.sceneWidthCm);
        const selectedWidthCm = Math.max(1, state.selectedWidthCm || 100);
        const targetTextWidthPx = vbW * (selectedWidthCm / sceneWidthCm);
        const byWidthScale = targetTextWidthPx / Math.max(1, built.width);

        // Safety cap so long text/multi-line always stays contained.
        const maxTextW = Math.min(fitW, vbW - TEXT_LAYOUT.innerPadPx * 2);
        const maxTextH = Math.min(fitH, vbH * 0.86);
        const containScale = Math.min(
          maxTextW / Math.max(1, built.width),
          maxTextH / Math.max(1, built.height)
        );
        const contentScale = Math.min(byWidthScale, containScale);

        const contentW = built.width * contentScale;
        const contentH = built.height * contentScale;
        const renderCenter = render.center || {};
        const centerX = vbW * clamp(Number(renderCenter.x) || 0.5, 0.12, 0.88);
        const centerY = vbH * clamp(Number(renderCenter.y) || 0.48, 0.18, 0.82);
        const tx = centerX - contentW * 0.5 - built.minX * contentScale;
        const ty = centerY - contentH * 0.5 - built.minY * contentScale;

        const left = tx + built.minX * contentScale;
        const right = tx + built.maxX * contentScale;
        const top = ty + built.minY * contentScale;
        const bottom = ty + built.maxY * contentScale;
        const dimY = Math.min(vbH - framePad * 0.4, bottom + DIM_ANN.gap + DIM_ANN.tick);
        const dimX = Math.max(framePad * 0.4, left - DIM_ANN.gap - DIM_ANN.tick);

        const widthLabel = `${(state.selectedWidthCm || 100).toFixed(0)}cm`;
        const sceneWidthMm = (state.selectedWidthCm || 100) * 10;
        const sceneHeightCm = (numberInput("hInput", sceneWidthMm / Math.max(0.001, state.textAspect)) / 10);
        const heightLabel = `${sceneHeightCm.toFixed(1)}cm`;
        const glowRgb = hexToRgb(state.strokeColor);
        const tubeRgb = softTubeColor(state.strokeColor);
        const tubeFill = `rgb(${tubeRgb.r}, ${tubeRgb.g}, ${tubeRgb.b})`;
        const glowFill = `rgb(${glowRgb.r}, ${glowRgb.g}, ${glowRgb.b})`;
        const tubeStrokeWidth = (coreStrokePx * 1.05).toFixed(4);
        const highlightStrokeWidth = (coreStrokePx * 0.45).toFixed(4);

        let neonContent = "";
        if (built.mode === "svg-text") {
          const ff = family || `Preview_${state.selectedFont.replace(/\s+/g, "_")}`;
          const lineEls = built.lines.map((line, idx) => {
            let baselineY = 0;
            for (let i = 0; i <= idx; i += 1) {
              baselineY += built.lineAsc[i];
              if (i < idx) baselineY += Math.max(0, built.lineAdvance - built.lineAsc[i] - built.lineDesc[i]);
            }
            const y = baselineY - built.minY;
            let x = 0;
            let anchor = "start";
            if (state.align === "center") {
              x = built.width / 2;
              anchor = "middle";
            } else if (state.align === "right") {
              x = built.width;
              anchor = "end";
            }
            return `<text x="${x.toFixed(3)}" y="${y.toFixed(3)}" text-anchor="${anchor}">${escapeXml(line)}</text>`;
          }).join("");
          neonContent = `
            <g font-family="${escapeXml(ff)}" font-size="${fontSize}" letter-spacing="${spacing}" stroke-linecap="round" stroke-linejoin="round">
              <g fill="${glowFill}" fill-opacity="0.24" stroke="${glowFill}" stroke-width="${(coreStrokePx * 5.8).toFixed(4)}" stroke-opacity="0.22" filter="url(#glowOuter)" style="mix-blend-mode:screen;">${lineEls}</g>
              <g fill="${glowFill}" fill-opacity="0.30" stroke="${glowFill}" stroke-width="${(coreStrokePx * 3.4).toFixed(4)}" stroke-opacity="0.30" filter="url(#glowMid)" style="mix-blend-mode:screen;">${lineEls}</g>
              <g fill="${glowFill}" fill-opacity="0.36" stroke="${glowFill}" stroke-width="${(coreStrokePx * 1.8).toFixed(4)}" stroke-opacity="0.38" filter="url(#glowInner)" style="mix-blend-mode:screen;">${lineEls}</g>
              <g fill="${tubeFill}" fill-opacity="0.98">${lineEls}</g>
              <g fill="none" stroke="${tubeFill}" stroke-width="${tubeStrokeWidth}" stroke-opacity="0.96">${lineEls}</g>
              <g fill="none" stroke="#fffefb" stroke-width="${highlightStrokeWidth}" stroke-opacity="0.72">${lineEls}</g>
            </g>
          `;
        } else {
          neonContent = `
            <path d="${pathD}" fill="${glowFill}" fill-opacity="0.24" stroke="${glowFill}" stroke-width="${(coreStrokePx * 5.8).toFixed(4)}" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.22" filter="url(#glowOuter)" style="mix-blend-mode:screen;" />
            <path d="${pathD}" fill="${glowFill}" fill-opacity="0.30" stroke="${glowFill}" stroke-width="${(coreStrokePx * 3.4).toFixed(4)}" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.30" filter="url(#glowMid)" style="mix-blend-mode:screen;" />
            <path d="${pathD}" fill="${glowFill}" fill-opacity="0.36" stroke="${glowFill}" stroke-width="${(coreStrokePx * 1.8).toFixed(4)}" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.38" filter="url(#glowInner)" style="mix-blend-mode:screen;" />
            ${redStrokePx > 0 ? `<path d="${pathD}" fill="none" stroke="#ff2d2d" stroke-width="${redStrokePx}" vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.95" />` : ``}
            <path d="${pathD}" fill="${tubeFill}" fill-opacity="0.98" />
            <path d="${pathD}" fill="none" stroke="${tubeFill}" stroke-width="${tubeStrokeWidth}" vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.96" />
            <path d="${pathD}" fill="none" stroke="#fffefb" stroke-width="${highlightStrokeWidth}" vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-opacity="0.72" />
          `;
        }

        svgMarkup = `
          <svg class="svg-root" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${vbW} ${vbH}" preserveAspectRatio="none">
            <defs>
              <filter id="glowOuter" x="-120%" y="-120%" width="340%" height="340%">
                <feGaussianBlur stdDeviation="7" />
              </filter>
              <filter id="glowMid" x="-120%" y="-120%" width="340%" height="340%">
                <feGaussianBlur stdDeviation="3.8" />
              </filter>
              <filter id="glowInner" x="-120%" y="-120%" width="340%" height="340%">
                <feGaussianBlur stdDeviation="1.8" />
              </filter>
            </defs>
            <g transform="translate(${tx.toFixed(4)},${ty.toFixed(4)}) scale(${contentScale.toFixed(6)})">
              ${neonContent}
            </g>
            <g stroke="${DIM_ANN.color}" stroke-width="${DIM_ANN.stroke}" fill="none" stroke-linecap="round">
              <line x1="${left.toFixed(2)}" y1="${dimY.toFixed(2)}" x2="${right.toFixed(2)}" y2="${dimY.toFixed(2)}" />
              <line x1="${left.toFixed(2)}" y1="${(dimY - DIM_ANN.tick).toFixed(2)}" x2="${left.toFixed(2)}" y2="${(dimY + DIM_ANN.tick).toFixed(2)}" />
              <line x1="${right.toFixed(2)}" y1="${(dimY - DIM_ANN.tick).toFixed(2)}" x2="${right.toFixed(2)}" y2="${(dimY + DIM_ANN.tick).toFixed(2)}" />

              <line x1="${dimX.toFixed(2)}" y1="${top.toFixed(2)}" x2="${dimX.toFixed(2)}" y2="${bottom.toFixed(2)}" />
              <line x1="${(dimX - DIM_ANN.tick).toFixed(2)}" y1="${top.toFixed(2)}" x2="${(dimX + DIM_ANN.tick).toFixed(2)}" y2="${top.toFixed(2)}" />
              <line x1="${(dimX - DIM_ANN.tick).toFixed(2)}" y1="${bottom.toFixed(2)}" x2="${(dimX + DIM_ANN.tick).toFixed(2)}" y2="${bottom.toFixed(2)}" />
            </g>
            <g fill="${DIM_ANN.textColor}" font-size="${DIM_ANN.fontSize}" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif">
              <text x="${((left + right) * 0.5).toFixed(2)}" y="${(dimY + DIM_ANN.fontSize + 6).toFixed(2)}" text-anchor="middle">${widthLabel}</text>
              <text x="${(dimX - 12).toFixed(2)}" y="${((top + bottom) * 0.5).toFixed(2)}" text-anchor="end" dominant-baseline="middle">${heightLabel}</text>
            </g>
          </svg>
        `;

        svgShell.innerHTML = svgMarkup;
        const iThicknessPx = coreStrokePx;
        const combinedPx = redStrokePx + iThicknessPx;
        if (metricRedStroke) metricRedStroke.textContent = `Trazo rojo: ${redStrokePx.toFixed(2)} px`;
        if (metricIThickness) metricIThickness.textContent = `Grosor interior: ${iThicknessPx.toFixed(2)} px`;
        if (metricCombined) metricCombined.textContent = `Combinado: ${combinedPx.toFixed(2)} px`;

        const allPaths = svgShell.querySelectorAll("path");
        allPaths.forEach((p) => {
          try { pathLength += p.getTotalLength(); } catch (_) {}
        });
        if (!pathLength && built.mode === "svg-text") {
          pathLength = built.lines.reduce((acc, line, i) => acc + (built.widths[i] || 0), 0);
        }
        if (lengthLabel) {
          lengthLabel.textContent = `Longitud del trazado: ${pathLength.toFixed(1)} unidades`;
        }
        const quote = computePricingEstimate();
        if (neonEstimateLabel) {
          neonEstimateLabel.textContent = `Longitud estimada de neón: ${quote.neonLengthCm.toFixed(1)} cm`;
        }
        if (priceLabel) {
          priceLabel.textContent = `Precio estimado: €${quote.total.toFixed(2)} + IVA`;
        }
        if (checkoutPriceOld) checkoutPriceOld.textContent = "";
        if (checkoutPriceNow) checkoutPriceNow.textContent = `€${quote.total.toFixed(2)}`;
        setStatus(`Renderizado en ${render.label || render.id} desde ${url}`);
      } catch (err) {
        addDiagnostic(`Falló el renderizado: ${String(err.message || err)}`);
      }
    }

    document.querySelectorAll(".align").forEach(btn => btn.addEventListener("click", async () => {
      document.querySelectorAll(".align").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      state.align = btn.dataset.align;
      await applyChanges();
    }));

    document.getElementById("textInput").addEventListener("input", async () => {
      const prevWidth = state.selectedWidthCm;
      syncSizeUiForTextDemand();
      if (state.selectedWidthCm !== prevWidth) {
        await applyChanges("w");
      } else {
        await applyChanges();
      }
    });
    sizeGrid.querySelectorAll(".size-chip").forEach((btn) => {
      btn.addEventListener("click", async () => {
        if (btn.classList.contains("disabled")) return;
        sizeGrid.querySelectorAll(".size-chip").forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        state.selectedWidthCm = parseFloat(btn.dataset.wcm) || 100;
        await applyChanges("w");
      });
    });
    if (addToCartBtn) addToCartBtn.addEventListener("click", addConfiguredSignToCart);
    renderFonts();
    renderSwatches();
    renderRenderSwitcher();
    initRenderSwipe();
    setMockupImage(activeRender());
    syncCheckoutAvailability();
    setView("render");
    validatePricingConfig();
    syncSizeUiForTextDemand();
    initFinalGallery();
    applyChanges();

    let resizeTimer = null;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        applyChanges();
      }, 120);
    });

    if (root) root.classList.remove("show-status");
})();
